import React from "react";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

const AboutUs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: isMobile ? "3rem 1.5rem" : isTablet ? "4.5rem 2rem" : "6rem 4rem",
  };

  const sectionTitle = {
    fontSize: isMobile ? "26px" : "38px",
    fontWeight: 700,
    color: "#1E1B4B",
    marginBottom: "20px",
  };

  const paragraphStyle = {
    fontSize: isMobile ? "14px" : "16px",
    lineHeight: "28px",
    color: "#4B5563",
    marginBottom: "18px",
  };

  const cardStyle = {
    padding: isMobile ? "24px" : "35px",
    borderRadius: "14px",
    backgroundColor: "#ffffff",
    border: "1px solid #E9E6F5",
    transition: "all 0.3s ease",
  };

  return (
    <>
      <section
        style={{
          background: "linear-gradient(135deg, #0F0A1F, #240046)",
          color: "#ffffff",
          padding: isMobile ? "4rem 1.5rem" : isTablet ? "5rem 2rem" : "6rem 4rem",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: isMobile ? "30px" : "48px",
            fontWeight: 700,
          }}
        >
          About InnoByte
        </h1>

        <p
          style={{
            maxWidth: "800px",
            margin: "20px auto 0",
            fontSize: isMobile ? "15px" : "18px",
            color: "#DCD6F7",
            lineHeight: "28px",
          }}
        >
          Delivering integrated infrastructure for modern businesses across
          data centres, enterprise networks, wireless environments, and
          electronics-led deployments.
        </p>
      </section>

      <section style={containerStyle}>
        <div style={{ maxWidth: "900px" }}>
          <h2 style={sectionTitle}>Who We Are</h2>

          <p style={paragraphStyle}>
            InnoByte is a technology system integrator focused on designing and
            delivering dependable IT and physical infrastructure for business
            environments. Our work spans data centre setup, structured cabling,
            enterprise Wi-Fi, secure networking, surveillance systems, and
            electronics hardware deployment.
          </p>

          <p style={paragraphStyle}>
            We support projects from initial planning and solution design
            through procurement, installation, configuration, testing, and
            post-deployment support. This end-to-end approach helps clients
            work with one accountable partner across their infrastructure
            lifecycle.
          </p>

          <p style={paragraphStyle}>
            We operate with an engineering-first mindset, ensuring every
            deployment is practical, scalable, secure, and aligned to long-term
            operational needs.
          </p>
        </div>
      </section>

      <section style={{ ...containerStyle, paddingTop: 0 }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isTablet ? "1fr" : "1fr 1fr",
            gap: isMobile ? "24px" : "40px",
          }}
        >
          <div
            style={cardStyle}
            onMouseEnter={(e) =>
              (e.currentTarget.style.boxShadow =
                "0 12px 30px rgba(106, 13, 173, 0.15)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.boxShadow = "none")
            }
          >
            <h3
              style={{
                fontWeight: 700,
                marginBottom: "15px",
                color: "#6A0DAD",
              }}
            >
              Our Mission
            </h3>

            <p style={paragraphStyle}>
              To deliver dependable, end-to-end infrastructure solutions that
              help organizations build resilient data, network, and facility
              environments for growth.
            </p>
          </div>

          <div
            style={cardStyle}
            onMouseEnter={(e) =>
              (e.currentTarget.style.boxShadow =
                "0 12px 30px rgba(106, 13, 173, 0.15)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.boxShadow = "none")
            }
          >
            <h3
              style={{
                fontWeight: 700,
                marginBottom: "15px",
                color: "#6A0DAD",
              }}
            >
              Our Vision
            </h3>

            <p style={paragraphStyle}>
              To be the trusted system integration partner for enterprises
              seeking high-performance infrastructure, seamless execution, and
              long-term service reliability.
            </p>
          </div>
        </div>
      </section>

      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "5rem 4rem",
          backgroundColor: "#F5F3FF",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <h2 style={sectionTitle}>Our Engineering Principles</h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile
                ? "1fr"
                : "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "40px",
              marginTop: "40px",
            }}
          >
            {[
              "Reliable Execution",
              "Standards-Driven Delivery",
              "Secure Infrastructure",
              "Long-Term Support",
            ].map((value, index) => (
              <div
                key={index}
                style={{
                  padding: "20px",
                  backgroundColor: "#ffffff",
                  borderRadius: "10px",
                  border: "1px solid #E9E6F5",
                  fontWeight: 600,
                  color: "#1E1B4B",
                }}
              >
                {value}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
